import React, { Component } from 'react';
import { HotelWizard } from './HotelWizard';
import { createHotel } from '../actions';
import { connect } from 'react-redux';
import { LOADED } from '../../utils/helpers/phases';
import { translate } from 'react-i18next';
import { setWarningMessage } from '../../messages/actions';
class HotelWizardContainer extends Component {
  componentDidUpdate() {
    if (this.props.phase === LOADED) {
      this.props.history.push('/');
    }
  }

  render() {
    return <HotelWizard {...this.props} />;
  }
}

const mapStateToProps = state => {
  return {
    phase: state.hotels.phase
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSubmit: hotel => {
      if (!hotel.hotelName) {
        dispatch(setWarningMessage('Name cannot be empty'));
        return;
      }
      //TODO: validate
      dispatch(createHotel(hotel));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate('translations')(HotelWizardContainer));



// WEBPACK FOOTER //
// ./src/hotels/Wizard/index.js